import { queryClient, apiRequest } from "../lib/queryClient";

const rolesKey = "roles";

export function useRoles(options = {}) {
  const {
    filters = {},
    sort = { field: "createdAt", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchRoles = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }
    const response = await apiRequest(`/admin/role?${queryParams.toString()}`, {
      method: "GET",
    });
    return response;
  };

  const fetchRoleById = async (roleId) => {
    const response = await apiRequest(`/admin/role/${roleId}`, {
      method: "GET",
    });
    return response;
  };

  const createRole = async (roleData) => {
    const response = await apiRequest("/admin/role", {
      method: "POST",
      body: JSON.stringify(roleData),
    });
    queryClient.invalidateQueries({ queryKey: [rolesKey] });
    return response;
  };

  const updateRole = async (roleData) => {
    const response = await apiRequest("/admin/role", {
      method: "PUT",
      body: JSON.stringify(roleData),
    });
    queryClient.invalidateQueries({ queryKey: [rolesKey] });
    return response;
  };

  const deleteRole = async (roleId) => {
    await apiRequest(`/admin/role/${roleId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [rolesKey] });
    return roleId;
  };

  const assignRole = async (user) => {
    const response = await apiRequest(`/admin/role/assign`, {
      method: "PUT",
      body: JSON.stringify(user),
    });
    queryClient.invalidateQueries({ queryKey: [rolesKey] });
    return response;
  };

  const fetchMyRole = async () => {
    const response = await apiRequest("/auth/admin/my-role", {
      method: "GET",
    });
    return response;
  };

  const removeRole = async (userId) => {
    const response = await apiRequest(`/admin/role/remove/${userId}`, {
      method: "PATCH",
    });
    return response;
  };
  return {
    fetchMyRole,
    fetchRoles,
    fetchRoleById,
    createRole,
    updateRole,
    deleteRole,
    assignRole,
    removeRole,
  };
}
